var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import ButtonComponent from './ButtonComponent';
import { DataContext } from '../player/DataContext';
import { selectTool } from '../helper/helper';
import globalStore from '../store';
import '../styles/selectFocusOverlay.scss';
// Reliable touch-primary detection — works on modern iPads (desktop UA)
var IS_TOUCH_DEVICE = typeof window !== 'undefined' && !!((_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(pointer: coarse)').matches);
/**
 * Transparent overlay button shown when a manipulative is not focused.
 * Clicking it selects/focuses the manipulative. Once focused, the overlay hides.
 * On touch devices, the button stays visible even when focused (for VoiceOver accessibility).
 *
 * Usage: place inside a position:relative wrapper as the first child.
 */
var SelectFocusOverlay = function (_a) {
    var id = _a.id, _b = _a.hidden, hidden = _b === void 0 ? false : _b, ariaLabel = _a.ariaLabel, className = _a.className, title = _a.title, _c = _a.showToolTip, showToolTip = _c === void 0 ? true : _c, _d = _a.useViewportPosition, useViewportPosition = _d === void 0 ? false : _d, onHoverChange = _a.onHoverChange, onAfterClick = _a.onAfterClick;
    var _e = useContext(DataContext), selectedTool = _e.selectedTool, setSelectedTool = _e.setSelectedTool;
    var btnConfig = globalStore.useStoreState(function (store) { return store.jsonDataStore; }).btnConfig;
    var isFocused = selectedTool.includes(id);
    // On touch devices, keep the button visible even when focused (for VoiceOver)
    if ((isFocused && !IS_TOUCH_DEVICE) || hidden)
        return null;
    return (_jsx(ButtonComponent, { defaultCSS: "selectFocusState ".concat(className), normalCSS: "selectFocusStateNormal", imgSrc: btnConfig.selectedFocus.imgSrc, clickHandler: function (e) {
            var newSelection = selectTool(e, id, selectedTool, false);
            setSelectedTool(newSelection);
            onAfterClick === null || onAfterClick === void 0 ? void 0 : onAfterClick(e);
        }, title: title, isWhiteBoard: true, showToolTip: showToolTip, onMouseDown: function (e) { return e.stopPropagation(); }, useViewportPosition: useViewportPosition, isParentRelative: true, ariaLabel: ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : 'text.select', onMouseOver: function (e) {
            onHoverChange === null || onHoverChange === void 0 ? void 0 : onHoverChange(true, e.currentTarget.getBoundingClientRect());
        }, onMouseOut: function (e) {
            // onMouseOut bubbles — ignore if the mouse moved to a child of the button
            if (e.currentTarget.contains(e.relatedTarget))
                return;
            onHoverChange === null || onHoverChange === void 0 ? void 0 : onHoverChange(false);
        }, onTouchEnd: function () { return onHoverChange === null || onHoverChange === void 0 ? void 0 : onHoverChange(false); } }));
};
export default SelectFocusOverlay;
